import React from 'react'
import "leaflet/dist/leaflet.css";

import  "./ColonyCard.scss"
import { useNavigate } from 'react-router-dom';
import { MapContainer, TileLayer } from 'react-leaflet';
import Pin from '../pin/Pin';

function ColonyCard({item}) {
    const navigate=useNavigate()

  // console.log("Colony Card Item: ",item)

  const handleColonyCardClick = (e,item) => {
      e.preventDefault();

        // alert(`Clicked Client ID: ${item?.id}`);
      try {
         navigate(`/admin/colony/${item.id}`, {
            state: { mode: 1, colonyid: item.id }
        });    

      } catch (error) {
        console.log(error)
      }


  };


// const lat = Number(item.latitude);
// const lng = Number(item.longitude);


  return (
    <div className="colonyCard" >

      <div className="firstCol" onClick={(e)=>handleColonyCardClick(e,item)}>
           <MapContainer
              // center={[20, 20]}

              center={[Number(item.latitude), Number(item.longitude)]}
// center={[
//     isFinite(lat) ? lat : 28.6139,
//     isFinite(lng) ? lng : 77.2090
//   ]}
              zoom={14}
              scrollWheelZoom={false}
              className="map"
            >
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {/* Optional: pins */}
              {/* {item.id && <Pin item={item} />} */}
            </MapContainer>
      </div>

      <div className="secondCol">
          <div className="colonyName">
              <label>Colony Name</label>
              <div className="colonyVal">
                  {item.colonyname}

              </div>
          </div>
          <div className="colonyCity">
              <label>City</label>
              <div className="cityVal">
                  {item.city}

              </div>
          </div>

      </div>


        

    </div>


  )
}

export default ColonyCard